import React, { useState, useEffect } from 'react';
import { Tooltip } from 'src/component/Tooltip';
import System from 'src/helper/system';
import ForecastHelpAbacus from 'src/assets/pdf/Forecast-help_abacus.pdf';
import ForecastHelpEBV from 'src/assets/pdf/Forecast-help_ebv.pdf';
import ForecastHelpSilica from 'src/assets/pdf/Forecast-help_silica.pdf';
import Constants from 'src/support/Constants';
import { useForecastStore } from 'src/hooks/forecast';
import SystemAlerts from 'src/component/SystemAlerts';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import store from 'src/storeWire';
import { system_notification } from 'src/store/slice/system';

const ForecastHeader = (props) => {
    const [{ forecast_counts }, { }, { }] = useForecastStore();
    const [forecastCountData, setForecastCountData] = useState([]);
    const [{ latest_system_notification_data }, { }, { }] = useDOMAttachToSystemStore();
    const [isFirstAPICall, setIsFirstAPICall] = useState(true);
    const [originalTotalCount, setOriginalTotalCount] = useState(0);

    useEffect(() => {
        if (!isFirstAPICall) {
            setOriginalTotalCount(forecast_counts?.total)
            setForecastCountData(forecast_counts);
        }
    }, [isFirstAPICall])

    useEffect(() => {
        if (forecast_counts && Object.keys(forecast_counts).length > 0) {
            setIsFirstAPICall(false);
        }
    }, [forecast_counts])

    const renderTooltip = (props) => (
        <div style={{ textAlign: 'left' }}>
            <div>
                <span><b>Total</b>: Total Part Count Received on last Forecast.</span>
            </div>
            <div>
                <span><b>Non Constraint</b>: No Shortages</span>
            </div>
            <div>
                <span><b>Constraint</b>: Shortages</span>
            </div>
        </div>
    );

    const getForecastInformation = () => {
        let _sBoat = System.getCurrentSiteSpeedboatShortName();
        if (_sBoat) {
            switch (_sBoat) {
                case 'S': return ForecastHelpSilica; break;
                case 'B': return ForecastHelpEBV; break;
                default: return ForecastHelpAbacus; break;
            }
        }
    }

    /**
     * Bug    #  : 9670
     * Change #  : Display download message on download
     * Change by : PN
     * Date      : 4 Aug 2023 
     */
    const showDownloadMessage = () => {
        System.alert(Constants.downloadMsg, 'success', 'exportMsg')
    }

    /** Story #  : 7070 - Open download popup when records count <= 1000 - PN - 18 Jan 2024 */
    const openForecastDownloadPopup = () => {
        if ((originalTotalCount * 6) < 1000) {
            store.dispatch(system_notification({
                name: 'DownloadForecastPopup',
                data: {},
            }));
        }
        else {
            System.alert('Your forecast file is too large. Your download was unsuccessful. Please select to "<b>Email</b>" the file.', 'warning', 'forecastDownloadErrMsg');
        }
    }

    return (
        <>
            <div className="pcn-page-head header-container d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap forecast-header">
                <div className="page-title font-oswald font-light font-30 mb-3 mb-sm-0">Forecast</div>
                <div className="ms-sm-auto mb-0">
                    <ul className="d-flex justify-content-start justify-content-lg-end list-unstyled mb-0">

                        <Tooltip
                            position={'bottom center'}
                            opener={() => (
                                <li className="ms-sm-4"><i className="fa fa-key me-2 text-black" aria-hidden="true"></i> <span className='text-blue2 cursor-default'>Key/Legend</span></li>
                            )}
                            content={() => (
                                renderTooltip()
                            )}
                        />

                        <li className="ms-4"><a href={getForecastInformation()} onClick={() => showDownloadMessage()} target='_blank'><i className="fa fa-info-circle me-2 text-black" aria-hidden="true"></i><span className='text-blue2'>Information</span></a></li>
                        <li className="ms-4"><a className={`${originalTotalCount > 0 ? '' : ' link-disabled'}`} onClick={() => openForecastDownloadPopup()}><i className="fa fa-download me-2 text-black"></i><span className='text-blue2'>Download</span></a></li>
                        <li className="ms-4">
                            <a className={`${originalTotalCount > 0 ? '' : ' link-disabled'}`} onClick={() => System.popup('ShareForecastPopup', { forecastCount: forecastCountData })}><i className="fa fa-envelope me-2 text-black" aria-hidden="true"></i><span className='text-blue2'>Email</span></a></li>
                    </ul>
                </div>
            </div>
            <div className="pcn-line-divider m-b-20"></div>
            {latest_system_notification_data.errorModule !== undefined && latest_system_notification_data.errorModule === 'forecastDownloadErrMsg' &&
                <SystemAlerts />
            }
        </>
    );
}

export default ForecastHeader;